import type { PayoutListResponseType } from "@sellar-io/api-v2/types";

import dayjs from "dayjs";

import { PayoutStatusFilterType } from "../stores/SellarCreditFilterStore";

export type ColumnDataType = PayoutListResponseType[number];

export function getLastFriday(dateInput: Date) {
  const date = dayjs(dateInput);
  // In dayjs, Sunday is 0 and Friday is 6.
  // Calculate how many days to subtract: (day + 1) % 7 gives the number of days
  // to go back to Friday.
  const daysToSubtract = (date.day() + 2) % 7;
  return date.subtract(daysToSubtract, "day");
}

export function getNextFriday(dateInput: Date) {
  const date = dayjs(dateInput);
  const targetDay = 5; // In dayjs: Sunday = 0, Monday = 1, …, Friday = 5

  // How many days to add to reach Friday:
  // (targetDay - currentDay + 7) % 7 gives 0 when you're on Friday,
  // so we OR with 7 to jump a full week in that case.
  const daysToAdd = (targetDay - date.day() + 7) % 7 || 7;

  return date.add(daysToAdd, "day");
}

export const getEmptyMessage = (
  search: string,
  status: PayoutStatusFilterType,
) => {
  if (search || status !== "all") return "Your search returned 0 results";
  return "No payouts currently available";
};
